import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {SmallTitleModule} from '../../shared/small-title/small-title.module';
import {LatestInformationComponent} from './latest-information.component';
@NgModule({
  imports: [
    CommonModule,SmallTitleModule
  ],
  declarations: [LatestInformationComponent],
  exports:[LatestInformationComponent],

})
export class LatestInformationModule { }



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/job/latest-information/latest-information.module.ts